import React from 'react'
import { Formik, FormikProps } from 'formik'
import { Button } from '../Button'
import { Input } from '../Input'
import { TextboxInput } from '../Input/input-component'
import { BusinessContactFormProps } from '../../types'
import { GoogleReCaptcha } from '../ReCaptcha'

const BusinessContactForm = ({
  initialValues,
  validationSchema,
  handleSubmit,
  reRef,
  captchaToken,
  setCaptchaToken,
}: BusinessContactFormProps) => {
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => {
          const {
            values,
            touched,
            errors,
            dirty,
            handleChange,
            handleSubmit,
          }: FormikProps<typeof initialValues> = formik
          return (
            <form>
              <div className='contact-us-input-row'>
                <div className='contact-us-input-group'>
                  <Input
                    labelText='First Name'
                    name='firstName'
                    placeholder='Enter your first name'
                    type='text'
                    required
                    value={values.firstName}
                    handleChange={handleChange}
                    dirty={dirty}
                    errors={{
                      firstName: errors?.firstName ?? null,
                    }}
                    touched={{ firstName: !!touched?.firstName }}
                  />
                </div>
                <div className='contact-us-input-group'>
                  <Input
                    labelText='Last Name'
                    name='lastName'
                    placeholder='Enter your last name'
                    type='text'
                    required
                    value={values.lastName}
                    handleChange={handleChange}
                    dirty={dirty}
                    errors={{
                      lastName: errors?.lastName ?? null,
                    }}
                    touched={{ lastName: !!touched?.lastName }}
                  />
                </div>
              </div>

              <div className='contact-us-input-row'>
                <div className='contact-us-input-group'>
                  <Input
                    labelText='Company'
                    name='company'
                    placeholder='Enter your company name'
                    type='text'
                    required
                    value={values.company}
                    handleChange={handleChange}
                    dirty={dirty}
                    errors={{
                      company: errors?.company ?? null,
                    }}
                    touched={{ company: !!touched?.company }}
                  />
                </div>
                <div className='contact-us-input-group'>
                  <Input
                    labelText='Email Address'
                    name='email'
                    placeholder='Enter your email address'
                    type='email'
                    required
                    value={values.email}
                    handleChange={handleChange}
                    dirty={dirty}
                    errors={{
                      email: !!errors && errors.email ? errors.email : null,
                    }}
                    touched={{ email: !!touched && !!touched.email }}
                  />
                </div>
              </div>

              <TextboxInput
                name='message'
                labelText='Message'
                placeholder='Enter the message'
                required
                value={values.message}
                handleChange={handleChange}
                dirty={dirty}
                errors={{
                  message: !!errors && errors.message ? errors.message : null,
                }}
                touched={{
                  message: !!touched && !!touched.message,
                }}
                maxLength={500}
                maxLengthErrorMessage='Message must be at most 500 characters'
              />

              <div className='contact-us-input-row'>
                <div className='g-captcha'>
                  <GoogleReCaptcha
                    handleChange={(value) => setCaptchaToken && setCaptchaToken(value)}
                    reCaptchaRef={reRef}
                    version='v2'
                  />
                </div>
                <div className='contact-us-submit'>
                  <Button
                    isDisabled={!captchaToken}
                    text='Submit'
                    classes={['mb-8 mt-14']}
                    variant='primary-btn'
                    handleClick={handleSubmit}
                  />
                </div>
              </div>
            </form>
          )
        }}
      </Formik>
    </>
  )
}

export { BusinessContactForm }
